import React from 'react';
import {Grid,Chip} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import {isEmpty} from 'lodash'
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const currencies = [
    {value: "Aktiv",label:<IntlMessages id="Table.active"/>,},
    {value: "Förfallen",label: <IntlMessages id="userProfile.Mail.notification.duedate" />  },
    {value: "Makulerad",label:<IntlMessages id="Invoice.Status.Shredded" />,},
    {value: "Obetald",label:<IntlMessages id="Invoice.Status.Unpaid" />,},
    {value: "Slutbetald",label:<IntlMessages id="Invoice.Status.paid" />,},
];
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: theme.spacing(1),
    }
  }));
  
function ChipsList(props) {
    const Userlista = useSelector(state => state.accountsData.Userlista)
    const ProspektFasList = useSelector(state => state.accountsData.ProspektFaslist)
    const Utokning = useSelector(state => state.accountsData.Utokning)
    const AfDistrikt = useSelector(state => state.accountsData.AfDistrikt)
    let YesOption = props.intl.formatMessage({ id: 'Option.Yes' });
    const AllLabel = props.intl.formatMessage({ id: 'All' });
    const classes = useStyles();
    const GetMeta =(Meta)=>{
        switch(Meta){
            case "Avtal fakturastatus":return "Betalstatus"
            case "OrderId":return "Ordernr"
            default:return Meta  
        }
    }
    const GetValue =(n)=>{
        switch(n.Meta){
            case "Ansvarig":
                if(parseInt(n.Value) === -1){
                return AllLabel
                }
                else{                    
                    const UserObject = Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "Ägare":
                if(parseInt(n.Value) === -1){
                return AllLabel
                }
                else{                    
                    const UserObject = Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "Order ägare":
                if(parseInt(n.Value) === -1){
                return AllLabel
                }
                else{                    
                    const UserObject = Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "Kundtyp": return getKundType(n.Value)
            case "Taggning":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    return n.Value
                }
            case "Distrikt":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    try{
                    return AfDistrikt.filter(item=>{return item.id === parseInt(n.Value)})[0].Name
                    }
                    catch(err){
                        return ''
                    }
                }
            case "Leverantör":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    return n.Value
                }
            case "Order leverantör":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    return n.Value
                }
            case "Prospekt fas":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                    }
                else{
                    const Fas = ProspektFasList.filter(item=>{return parseInt(item.Ordering) === parseInt(n.Value)})
                    return `${Fas[0].FasNamn}`
                }
            case "Fria fält":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                    }
                else{
                    const ObjektName = Utokning.filter(item=>{return parseInt(item.id) === parseInt(n.Value)})
                    return `${ObjektName[0].ObjektName}`
                }
            case "Avtal fakturastatus":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                    }
                else{
                    const ObjektName = currencies.filter(item=>{return item.value === n.Value})
                    return `${ObjektName[0].value}`
                }
            case "Firmatecknare":return getFirmat(n.Value)
            case "Avtal status":return getAvtalstatus(n.Value)
            case "Order status":return getOrderstatus(n.Value)
            case "Prospekt status":return getProspektstatus(n.Value)
            case "Avtal/Prospekt":return getAvtalprospekt(n.Value)
            case "Avtal skapa datum F.O.M":return n.Value
            case "Avtal skapa datum T.O.M":return n.Value
            case "Avtal omförhandling datum F.O.M":return n.Value
            case "Avtal omförhandling datum T.O.M":return n.Value
            case "Avtal löper ut datum F.O.M":return n.Value
            case "Avtal löper ut datum T.O.M":return n.Value
            case "Prospekt deadline datum F.O.M":return n.Value
            case "Prospekt deadline datum T.O.M":return n.Value
            case "Order skapad datum F.O.M":return n.Value
            case "Order skapad datum T.O.M":return n.Value
            case "Order registrering datum F.O.M":return n.Value
            case "Order registrering datum T.O.M":return n.Value
            case "Betalatdatum F.O.M":return n.Value
            case "Betalatdatum T.O.M":return n.Value
            case "Typ":  
                if(parseInt(n.Value) === -1){
                return AllLabel
            }else{
                return n.Value
            }
            case "Ordertyp":  
                if(parseInt(n.Value) === -1){
                return AllLabel
            }else{
                return n.Value
            }
            default: return `${parseInt(n.Value)===0?YesOption:""}`
        }
    }
    const getKundType=(type)=>{
        switch(parseInt(type)){
            case -1:return AllLabel
            case 0:return <IntlMessages id="Consumer"/>
            case 1:return <IntlMessages id="Enterprise"/>
            case 2:return <IntlMessages id="Branch"/>
            case 3:return <IntlMessages id="Supplier"/>
            case 4:return <IntlMessages id="Resource"/>
        }
    }
    const getFirmat=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 0:return "Ja"
            case 1:return "Nej"
        }
    }
    const getAvtalstatus=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 1:return props.intl.formatMessage({ id: 'Active' })
            case 2:return props.intl.formatMessage({ id: 'Completed' })
        }
    }
    const getOrderstatus=(Firma)=>{
        if(parseInt(Firma) === -1){return AllLabel}
        if(isEmpty(props.OrderStatusList)){
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 2:return "Ny"
            case 3:return "Behandlas"
            case 4:return "Kompletteras"
            case 5:return "Klar"
        }
        }
        else{
            let Sttsta=props.OrderStatusList.filter(item=>{return parseInt(item.Value) === parseInt(Firma) && item.Meta !=="HO.KLAR" && item.Meta !=="HC.KLAR"}) 
            console.log(Sttsta)
            console.log(props.OrderStatusList)
            return Sttsta[0].Meta
        }
    }
    const getProspektstatus=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 1:return props.intl.formatMessage({ id: 'Active' })
            case 2:return props.intl.formatMessage({ id: 'Label.Lost' })
        }
    }
    const getAvtalprospekt=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case -2:return "Utan"
            case 1:return  <IntlMessages id="File.type.Contract"/>
            case 2:return <IntlMessages id="Prospectus"/>
            case 3:return "Omförhandlad avtal"
            case 4:return "Försäljning"
        }
    }
    console.log(props.Mstate,"DDDa")
    return (
        <>
        <Grid container className={classes.root} spacing={1}>
           {    
                isEmpty(props.Mstate)?"":
                props.Mstate.map((n,index) => {
                    if(n.Checked){
                        return (
                            <Grid item key={index} >
                                <Chip 
                                color="primary" 
                                size="small" 
                                style={{background:"#0c969c", color:"#fff",borderRadius:"0"}}
                                label={`${GetMeta(n.Meta)}: ${GetValue(n)}`}
                                />
                            </Grid>
                           )
                    }                   
               })
           } 
        </Grid>
        
        </>
    );
}
export default injectIntl(ChipsList);